const { RichText, InspectorControls, ColorPalette, MediaUpload } = wp.blockEditor;
const { PanelBody, RangeControl, Button, Flex, FlexBlock, FlexItem } = wp.components;

const Inspector = (props) => {
	
	const { attributes, setAttributes } = props;
	return(
		<InspectorControls style={ {  marginBottom: '40px' } }>

            <PanelBody title={ 'Body Color Settings' }>
                    <p>
                        <strong>Select a Body Color:</strong>
                    </p>
                    <ColorPalette value={ attributes.bodyColor }
                                  onChange={ (newBodyColor) => setAttributes({bodyColor: newBodyColor}) } />
            </PanelBody>


            <PanelBody title={ 'Background Image Settings' }>
                <p>
                    <strong>Select a Background Image:</strong>
                </p>
                <MediaUpload
                    onSelect={( newImage ) => setAttributes({ bgImage: newImage })}
                    type="image"
                    value={ attributes.bgImage }
                    render={ ( { open } ) => {
                        return(
                            <Button 
				            	className={Object.keys(attributes.bgImage).length === 0 && attributes.bgImage.constructor === Object ? 'editor-post-featured-image__toggle' : 'editor-post-featured-image__preview'}
				            	onClick={open}
				            >
				            {Object.keys(attributes.bgImage).length === 0 && 'Select image'}
						            	
						            	{Object.keys(attributes.bgImage).length !== 0 && 
											<Flex>
												<FlexBlock>
													<FlexItem>
											            <img 	src={attributes.bgImage.url}
																height={attributes.bgImage.sizes.medium.height}
																width={attributes.bgImage.sizes.medium.width}
														/>
													</FlexItem>
												</FlexBlock>
											</Flex>
										}
				            </Button>
                        )
                    } } />

                    <div style={ { marginTop: '20px', marginBottom: '40px'  } }>
                        <p>
                            <strong>Overlay Color:</strong>
                        </p>
                        <ColorPalette value={ attributes.overlayColor }
                                      onChange={ (newColor) => setAttributes({overlayColor: newColor}) } />
                    </div>
                    <RangeControl label={ 'Overlay Opacity' }
                                  value={ attributes.overlayOpacity }
                                  onChange={ (newOverlayOpacity) => setAttributes({overlayOpacity: newOverlayOpacity}) }
                                  min={ 0 }
                                  max={ 1 }
                                  step={ 0.05 } />
            </PanelBody>
        </InspectorControls>
	)
}

export default Inspector;